import { Injectable } from '@angular/core';
import { UserWizardService } from '../../../services/user/user.wizard.service';
import {
  ApiService,
  InputDatastoreService,
  CountryListService,
  DialogService,
  UserService,
  ValuesExchangeProvider
} from '@nrwl/common-lib';

@Injectable()
export class UserAddToGroupWizardService extends UserWizardService {
  constructor(
    apiService: ApiService,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService,
    readonly userService: UserService,
    valuesExchange: ValuesExchangeProvider
  ) {
    super(
      apiService,
      inputDatastoreService,
      countryListService,
      dialogService,
      userService,
      valuesExchange
    );
  }

  //------------------------------------------------ Wizard control ----------------------------------------------------

  onFinish(): void {
    const outputs = this.currentStep.output.groupId;
    if (outputs.length > 0) {
      const dataUrl = '/ims/v2/users/';
      let responseProcessed;
      for (let i = 0; i < outputs.length; i++) {
        this.dataUrl = dataUrl + this.defaultParamsById.id + '/groups/' + outputs[i].id;
        responseProcessed = this._saveRequest({ groupId: outputs[i].id }, true);
        responseProcessed.subscribe(() => {
          this.currentStep = this.finishingStep;
          if (!this.requestFailed && i === outputs.length - 1) {
            this.successMessage = 'Groups have been successfully added';
            this.valuesExchange.notifyListeners('user_admin_board', {
              value: 'update',
              cacheBreaker: Date.now()
            });
          }
        });
      }
      return responseProcessed;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  _handleErrorResponse(response: any): void {
    this.errorMessage = 'Groups were not added';

    if (response && response.error && response.error.errors.length !== 0) {
      this.errorDescription = response.error.errors[0];
    }
  }
}
